import React, { useState } from 'react';
import { getReporteEspecifico } from "../api";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { PieChart, Pie, Cell, Legend, Tooltip, ResponsiveContainer } from 'recharts';

const ReporteProductos = () => {
    const [mes, setMes] = useState(new Date().getMonth() + 1);
    const [anio, setAnio] = useState(new Date().getFullYear());
    const [reporte, setReporte] = useState({});
    const [cargando, setCargando] = useState(false);
    const [error, setError] = useState(null);
    
    const colores = ['#348feb', '#82ca9d', '#ffc658', '#ff6b6b'];
    const obtenerReporte = async () => {
        setCargando(true);
        setError(null);

        try {
            const response = await getReporteEspecifico(mes, anio); // axios.get()

            const data = response.data;

            setReporte(data);
        } catch (err) {
            console.error('❌ Error al obtener el reporte:', err);
            setError('Error al obtener el reporte');
        } finally {
            setCargando(false);
        }
    };

    const agruparPorEstado = (productos) => {
    const conteo = {};
    productos.forEach(p => {
        conteo[p.estado] = (conteo[p.estado] || 0) + 1;
    });
    return Object.entries(conteo).map(([estado, cantidad]) => ({
        name: estado,
        value: cantidad
    }));
    };

    const generarPDF = () => {
    const doc = new jsPDF();
    let y = 10;

    doc.setFontSize(13);
    doc.text(`Reporte de Productos de ${mes}/${anio}`, 10, y);
    y += 5;

    Object.entries(reporte).forEach(([categoria, productos]) => {
        doc.setFontSize(7);
        doc.text(categoria, 10, y);
        y += 5;

        const data = productos.map((p) => [
        p.id,
        p.codigo,
        p.descripcion,
        p.estado,
        p.creado_por,
        p.fecha_creacion,
        p.fecha_cierre
        ]);

        autoTable(doc, {
        head: [["ID", "Código", "Descripción", "Estado actual", "Solicitante", "Fecha creación","Fecha cierre"]],
        body: data,
        startY: y,
        theme: "striped",
        styles: { fontSize: 7 },
        margin: { left: 10, right: 10 },
        headStyles: { fillColor: [235, 64, 52] },
        didDrawPage: (data) => {
            y = data.cursor.y + 10;
        },
        });

        if (y > 270) {
        doc.addPage();
        y = 10;
        }
    });

    doc.save(`reporte-${mes}-${anio}.pdf`);
    };
    

  return (
    <div className="p-6">
      <h2 className="text-2xl font-bold mb-6">Reporte Historico de Productos</h2>

      <div className="flex flex-wrap gap-4 mb-6 items-center">
        <select
          value={mes}
          onChange={(e) => setMes(Number(e.target.value))}
          className="input3"
        >
          {[...Array(12)].map((_, i) => (
            <option key={i} value={i + 1}>
              {i + 1} - {new Date(0, i).toLocaleString('default', { month: 'long' })}
            </option>
          ))}
        </select>

        <input
          type="number"
          value={anio}
          onChange={(e) => setAnio(Number(e.target.value))}
          className="input3"
          min="2000"
          max="2100"
        />

        <button
          onClick={obtenerReporte}
          className="button-form-blue"
        >
          Consultar reporte
        </button>
      </div>

      {cargando && <p className="text-gray-600">Cargando reporte...</p>}
      {error && <p className="text-red-500">Error: {error}</p>}

      {!cargando && !error && (
        <div>
          <button
            onClick={generarPDF}
            className="button-form-gray"
          >
            Descargar PDF
          </button>

          {Object.keys(reporte).length === 0 ? (
            <p className="text-gray-600">No hay datos para este mes.</p>
          ) : (
            Object.entries(reporte).map(([categoria, productos], idx) => (
              <div key={categoria} className="mb-10">
                <h3 className="text-xl font-semibold mb-2">{categoria}</h3>
                <p className="mb-4">Total de productos: <strong>{productos.length}</strong></p>

                <ResponsiveContainer width="100%" height={250}>
                  <PieChart>
                    <Pie
                      data={agruparPorEstado(productos)}
                      dataKey="value"
                      nameKey="name"
                      cx="50%"
                      cy="50%"
                      outerRadius={80}
                      fill="#348feb"
                      label
                    >
                      {agruparPorEstado(productos).map((entry, index) => (
                        <Cell key={`cell-${index}`} fill={colores[index % colores.length]} />
                      ))}
                    </Pie>
                    <Tooltip />
                    <Legend verticalAlign="bottom" height={36} />
                  </PieChart>
                </ResponsiveContainer>


              </div>
            ))
          )}
        </div>
      )}
    </div>
  );
};

export default ReporteProductos;
